import {React} from "react";
import styled  from "styled-components";


import imgRadio75 from '../img/radio75.jpeg'
import imgradio75Overzicht from '../img/radio75overzicht.jpeg'
import imgradioombouw from '../img/radioombouw.jpeg'



const IpCarContainer = styled.div`

    position: relative;
    padding-top: 100px;
    width: 100%;
    height: 100%;
    color: white;
    z-index: 1;

    iframe{
      width: 50vw;
      height: calc(50vw/1.77);
    }
   
    h1{
      padding-top: 50px;
      margin:0;
      margin-left:20%;
      text-align: left;
    }
    p{
      text-align: left;
      width: 60%;
      margin-left:20%;
      
    }

  @media only screen and (max-width: 500px) {

      iframe{
        width: 90vw;
        height: calc(90vw/1.77);
       }
    
       h1{
        margin-left:10%; 
      }

      p{
        text-align: left;
        width: 80%;
        margin-left:10%;  
      }
}
`
const ImgContainer = styled.div`
padding-top: 50px;
width: 90%;
height:100%;
margin-left:5%;


`

const Row = styled.div`

  width: 100%;
  margin: auto;


  img{
    display: block;
  width: 80%;
  height: auto;
  margin: auto;
  padding-bottom: 50px;
  }
`

function Nporadio5() {


  return (
    <IpCarContainer>
      <iframe 
              src="https://www.youtube.com/embed/5wVrG5Xol4E?modestbranding=0&autohide=1&showinfo=1&controls=0&autoplay=1"
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen>
            </iframe>
            <h1>Arbeidsvitamine</h1>
            <p>Arbeidsvitamine is de langst lopende radioshow in de wereld en heeft in 2021 zijn  75 jarig jubliem gevierd.
            </p>
            <p>Voor deze viering is Circus Family gevraagd een installatie te maken van 75 radio’s één voor elk jaar “Arbeidsvitamine”,
               samen vormen deze radio’s het getal 75. Doormiddel van een knop kunnen bezoekers een radio selecteren die vervolgens een 
               populair nummer gaat spelen uit het des betreffende jaar. 
             </p>
             <p>Voor deze installatie heb ik Circus Family geholpen met het ombouwen van de radio’s. 
               Zo heb ik oude elektronica eruit gehaald en nieuwe elektronica geplaatst, geprogrammeerd en getest. 
             </p>
             <p>Ervaringen: solderen, ESP32, electronics, Arduino
             </p>

            <ImgContainer>
              <Row>
            
                  <img src={imgRadio75} alt="Radio"  />
                  <img src={imgradio75Overzicht} alt="Radio" />
          
                
              </Row>
              <Row>
           
                  <img src={imgradioombouw} alt="Radio" style={{width: "40%", height: "auto"}} />
        
             
                
              </Row>
            </ImgContainer>
    </IpCarContainer>
  );
}
export default Nporadio5;